import type {Worker} from "@mytour/shared";
import {useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useDeleteWorker} from "../../../../query/teamWorkerQueries.js";

interface DeleteWorkerActionProps {
  worker: Worker;
}

export function DeleteWorkerAction({worker}: DeleteWorkerActionProps) {
  const {deleteWorker, isDeletingWorker} = useDeleteWorker();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleConfirm = async () => {
    await deleteWorker(worker.id);
    setIsConfirmOpen(false);
  };

  return (
    <>
      <Button
        size="sm"
        color="danger"
        outline
        onClick={() => setIsConfirmOpen(true)}
        disabled={isDeletingWorker}
      >
        Supprimer
      </Button>

      {isConfirmOpen && (
        <DeleteConfirmationModal
          isOpen={isConfirmOpen}
          worker={worker}
          onConfirm={handleConfirm}
          onCancel={() => setIsConfirmOpen(false)}
        />
      )}
    </>
  );
}

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  worker: Worker;
  onConfirm: () => void;
  onCancel: () => void;
}

function DeleteConfirmationModal({
  isOpen,
  worker,
  onConfirm,
  onCancel,
}: DeleteConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>Confirmer la suppression</ModalHeader>
      <ModalBody>
        <p>
          Êtes-vous sûr de vouloir supprimer l'intervenant{" "}
          <strong>
            {worker.firstName} {worker.lastName}
          </strong>{" "}
          ?
        </p>
        <p className="text-muted">
          Cette action est irréversible. Les rendez-vous passés associés à cet intervenant seront
          conservés mais l'intervenant ne pourra plus se connecter.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Annuler
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Supprimer
        </Button>
      </ModalFooter>
    </Modal>
  );
}
